import { ArrowSmRightIcon } from '@heroicons/react/solid';
import { Button } from '@chakra-ui/react';
import Link from 'next/link';

export function GetStarted({ doc }: { doc: string }) {
  return (
    <section className="mt-10 mb-6">
      <div className="mx-auto mt-5 flex w-full flex-col items-center justify-center px-4 sm:flex-row sm:gap-4 sm:px-0 md:mt-8">
        <Link legacyBehavior href={doc}>
          <Button variant={'white'} minW="225px" fontSize={'md'}>
            Explore the Docs
          </Button>
        </Link>

        <Link href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-up`}>
          <Button
            rightIcon={<ArrowSmRightIcon className="inline h-6 w-6" />}
            minW="225px"
            fontSize={'md'}
          >
            Start Building Now
          </Button>
        </Link>
      </div>
    </section>
  );
}
